export const formatUnitOfTime = (unitOfTime: number) => (unitOfTime < 10 ? `0${unitOfTime}` : unitOfTime);
